import React, { useEffect, useState } from "react";
import useAxios from "../../../Utils/useAxios";
import EditStatusRealokasi from "../components/EditStatusRealokasiModal";
import DeleteRealokasi from "../components/DeleteRealokasiModal";
import RincianRealokasi from "../components/RincianRealokasi";
import FilterComponent from "../../FilterComponents/FilterComponent";
import { filterSearch } from "../../../Utils/FilterItems";
import { useThemeContext } from "../../../Context/ThemeContext";
import FeatureContainer from "../../../Layout/Containers/FeatureContainer";
import CreateButton from "../../../CommonElements/Button/CreateButton";
import { FEATURE_FUNCTION_SELECTION } from "../../../Constant/FeatureSelection";
import ListRealokasi from "../components/ListRealokasi";
import getRealokasiColumns from "../constants/getRealokasiColumns";
import { getRealokasi } from "../services";

const RealokasiContain = () => {
  const axiosInstance = useAxios();

  const [realokasiList, setRealokasiList] = useState([]);
  const [selectedRealokasi, setSelectedRealokasi] = useState(null);

  const [editStatusModalOpen, setEditStatusModalOpen] = useState(false);
  const toggleEditStatusModal = () =>
    setEditStatusModalOpen(!editStatusModalOpen);

  const [rincianModalOpen, setRincianModalOpen] = useState(false);
  const toggleRincianModal = () => setRincianModalOpen(!rincianModalOpen);

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const toggleDeleteModal = () => setDeleteModalOpen(!deleteModalOpen);

  const [pending, setPending] = useState({
    realokasi: false,
    status: false,
  });
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const { themeContext } = useThemeContext();

  let isMounted = true;
  useEffect(() => {
    const fetchData = async () => {
      await refreshRealokasi();
    };

    if (isMounted) fetchData();

    return () => {
      isMounted = false;
    };
  }, []);

  const refreshRealokasi = async () => {
    setPending((prev) => ({
      ...prev,
      realokasi: true,
      status: true,
    }));

    const { data: realokasiData } = await getRealokasi(axiosInstance).finally(
      () => setPending((prev) => ({ ...prev, realokasi: false, status: false }))
    );
    setRealokasiList(realokasiData);
    return realokasiData;
  };

  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  const handleEditStatusRealokasi = async (realokasi) => {
    setSelectedRealokasi(realokasi);
    toggleEditStatusModal();
  };

  const handleLihatRealokasi = async (realokasi) => {
    setSelectedRealokasi(realokasi);
    toggleRincianModal();
  };

  const handleDeleteRealokasi = async (realokasi) => {
    setSelectedRealokasi(realokasi);
    toggleDeleteModal();
  };

  const filterRealokasi = (items) => {
    const searchCategories = [
      "id_realokasi",
      "diajukan_oleh",
      "keterangan",
      "alasan",
      "nm_org",
      "nm_keg",
      "kd_keg",
      "nm_akun",
      "kd_akun",
    ];
    const filteredItems = items.filter(
      filterSearch(searchCategories, filterText)
    );
    return filteredItems;
  };

  return (
    <FeatureContainer
      title={"Realokasi"}
      statusList={filterRealokasi(realokasiList)}
      pending={pending?.status}
      refreshList={refreshRealokasi}
      createButton={
        FEATURE_FUNCTION_SELECTION.Realokasi.Create && (
          <CreateButton
            url={`${process.env.PUBLIC_URL}/realokasi/buatrealokasi`}
          >
            Buat Realokasi
          </CreateButton>
        )
      }
    >
      <ListRealokasi
        data={filterRealokasi(realokasiList)}
        columns={getRealokasiColumns({
          themeContext,
          handleLihatRealokasi,
          handleEditStatusRealokasi,
          handleDeleteRealokasi,
        })}
        subHeaderComponent={
          <FilterComponent
            onFilter={(e) => {
              setFilterText(e.target.value);
            }}
            onClear={() => handleClear()}
            filterText={filterText}
          />
        }
        pending={pending?.realokasi}
      />
      {selectedRealokasi && (
        <EditStatusRealokasi
          isOpen={editStatusModalOpen}
          toggle={toggleEditStatusModal}
          selectedRealokasi={selectedRealokasi}
          refreshRealokasi={refreshRealokasi}
          axiosInstance={axiosInstance}
        />
      )}
      {selectedRealokasi && (
        <DeleteRealokasi
          isOpen={deleteModalOpen}
          toggle={toggleDeleteModal}
          selectedRealokasi={selectedRealokasi}
          refreshRealokasi={refreshRealokasi}
          axiosInstance={axiosInstance}
        />
      )}
      {selectedRealokasi && (
        <RincianRealokasi
          isOpen={rincianModalOpen}
          toggle={toggleRincianModal}
          selectedRealokasi={selectedRealokasi}
          refreshRealokasi={refreshRealokasi}
          axiosInstance={axiosInstance}
        />
      )}
    </FeatureContainer>
  );
};
export default RealokasiContain;
